import { Component } from '@angular/core';
import { WorkshopJobService } from '../../shared/services/workshop-job.service';
import { WorkshopJobListStoreService } from './workshop-job-list-store.service';
import * as testIds from '../../../testIds/workshop';
import { WorkshopJobListComponent } from './workshop-job-list/workshop-job-list.component';
import { WorkshopListFilterComponent } from './workshop-list-filter/workshop-list-filter.component';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-workshop-index',
    templateUrl: './workshop-index.component.html',
    providers: [WorkshopJobService, WorkshopJobListStoreService],
    standalone: true,
    imports: [MatButton, RouterLink, WorkshopListFilterComponent, WorkshopJobListComponent]
})
export class WorkshopIndexComponent {
  testIds = testIds;
}
